import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Alert, Container, Row } from 'reactstrap';

import bannerLogo from '../images/Jook_Web_White.png';

import api from '../utils/Api';
import { trackEvent } from '../utils/Analytics';
import ResendVerification from './ResendVerification';

import './LoginView.scss';

/** Where the link in the sign-up email lands. Confirms the email, then offers sign-in. */
const VerifyEmailView = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get('email') || '';
  const key = params.get('key') || '';
  const [state, setState] = React.useState<'checking' | 'done' | 'failed'>('checking');
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    api
      .auth('verify-email', 'POST', { email, key })
      .then(() => {
        trackEvent('email_verified');
        setState('done');
      })
      .catch(err => {
        setError(err.message);
        setState('failed');
      });
  }, [email, key]);

  return (
    <Container fluid>
      <Row className="public-header-row">
        <div className="col public-header">
          <div className="d-flex justify-content-between">
            <Link to="/">
              <img className="logo" src={bannerLogo} alt="Jookable logo image" />
            </Link>
            <div />
          </div>
        </div>
      </Row>

      <Row className="g-0">
        <div className="col">
          <div className="public-page-content">
            <div className="public-page-formwrapper">
              <h1 className="public-page-formaccess">Confirm Email</h1>
              <div className="public-page-form">
                {state === 'checking' && <p>Checking your link...</p>}
                {state === 'done' && <Alert color="success">Your email is confirmed. You can sign in now.</Alert>}
                {state === 'failed' && (
                  <>
                    <Alert color="danger">{error}</Alert>
                    {email && <ResendVerification email={email} />}
                  </>
                )}
              </div>
              <div className="signin-link-wrapper">
                <Link to="/" className="signin-link">
                  {state === 'done' ? 'Sign In' : 'Back to Sign In'}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default VerifyEmailView;
